<h2 class="header-top">{{ props.header }}</h2>
<div class="row">
  @for (field of field.fieldArray['fieldGroup']; track field.id) {
    <div class="col">
      {{ field.props.label }}
    </div>
  }
  @if (!menuService.isReadOnly) {
    <div class="col icon">
      <a class="text-primary" (click)="add(newAtTop ? 0 : undefined)"><i class="fa fa-plus fa-lg"></i></a>
    </div>
  }
</div>
@for (field of field.fieldGroup; track field; let i = $index) {
  <div class="row mb-2">
    @for (field of field.fieldGroup; track field.id) {
      <div class="col">
        <formly-field [field]="field"></formly-field>
        @if (showError) {
          <div class="invalid-feedback d-block">
            <formly-validation-message [field]="field"></formly-validation-message>
          </div>
        }
      </div>
    }
    @if (!menuService.isReadOnly) {
      <div class="col icon pt-1">
        <a class="text-danger" (click)="delete(i)"><i class="fa fa-trash-alt fa-lg"></i></a>
      </div>
    }
  </div>
}
